<template lang="pug">
  v-app
    Notification
    Modal(:isShow="isShowModal", @close-modal="isShowModal = false", @send-report="submitReport")
    ErrorSideBar(
      :validationErrorsList="validationErrorsList",
      :show="show",
      @close-error-side-bar="show = false",
      @goto-id="gotoId")
    Toolbar(
      :errors="validationErrorsList.length",
      @submit-report="validationControls",
      @draft-report="draftReport",
      @calculate-report="calculateReport",
      @back-to="backTo",
      @show-error-side-bar="show = !show")
    Preloader(v-if="showPreloader")
    v-content(class="pt-5")
      v-container(fluid)
        ReportItem(
          :report="item",
          :index="index",
          :ref="'iframe_' + index",
          :page="index.replace(/[^0-9]/g, '')",
          v-for="(item, index) in reportTemplate",
          :key="index",
          @show-help="showHelp",
          @data-from-html="getDataFromHtml",
          :errorFieldId="errorId").mt-4
</template>

<script>
export default {
  components: {
    Notification: () => import('../common/Notification'),
    Modal: () => import('./common/Modal'),
    ErrorSideBar: () => import('./common/ErrorSideBar'),
    Toolbar: () => import('../ReportPage/common/Toolbar'),
    ReportItem: () => import('../ReportPage/common/ReportItem'),
    Preloader: () => import('../common/Preloader/Preloader')
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    statReportId: {
      type: String,
      default: '0'
    }
  },
  data: () => ({
    show: false,
    helpValue: null,
    tab: 0,
    helpInfo: {},
    report: {},
    validationErrorsList: [],
    errorId: '',
    isShowModal: false
  }),
  destroyed() {
    this.$store.commit('CLEAR_VALIDATION_ERRORS')
    this.$store.commit('CLEAR_RESPONDENT_PARAMS')
  },
  mounted() {
    if (this.isCurator) {
      this.$store.dispatch('GET_REPORT_TEMPLATE', {
        name: this.$route.params.id,
        reportId: this.statReportId,
        ...this.params
      })
    } else {
      this.$store.dispatch('GET_REPORT_TEMPLATE', {
        name: this.$route.params.id,
        reportId: this.statReportId
      })
    }
  },
  watch: {
    validationErrors(val) {
      if (val) {
        this.validationErrorsList = val
      }
    }
  },
  computed: {
    params() {
      return this.$store.state.respondents.respondentParams
    },
    isCurator() {
      return this.$store.state.profile.isAdmin
    },
    showPreloader() {
      return this.$store.state.reporting.isPreloader
    },
    reportTemplate() {
      return this.$store.state.reporting.reportTemplate
    },
    validationErrors() {
      return this.$store.state.reporting.errors.validation
    },
    permissibleControls() {
      return this.$store.state.reporting.errors.controls
    }
  },
  methods: {
    gotoId(id) {
      this.errorId = id
    },
    getDataFromHtml(data, index, total) {
      let page = `page${index}`
      this.report[page] = data
      if (total === index) {
        this.$store.dispatch('CALCULATE_REPORT', {
          report: this.report,
          id: this.$route.params.id
        })
        this.validationErrorsList = []
        this.show = false
      }
    },
    calculateReport() {
      let count = Object.keys(this.reportTemplate).length
      for (let index = 0; index < count; index++) {
        this.$refs[`iframe_page${index + 1}`][0].calculateReport(index + 1, count)
      }
    },
    backTo() {
      this.$router.go(-1)
      this.$store.commit('CLEAR_REPORT_TEMPLATE')
      this.$store.commit('SET_DISABLED_SEND_REPORT_BTN', true)
    },
    showHelp(id) {
      if (id !== null) {
        this.helpValue = id.replace(/\D+/g, '') - 1
        this.help = true
      }
    },
    validationControls() {
      if (this.permissibleControls !== null) this.isShowModal = true
      else this.submitReport()
    },
    submitReport(controls) {
      this.$store
        .dispatch('SUBMIT_REPORT', {
          reportId: this.statReportId,
          reportKey: this.$route.params.id,
          isCurator: this.isCurator,
          ...this.params,
          controls
        })
        .then(() => {
          this.isShowModal = false
        })
    },
    getValuesFromReportPage() {
      Object.keys(this.reportTemplate).map(async item => {
        this.report[item] = await this.$refs[`iframe_${item}`][0].$refs.iframe.contentWindow.getPage()
      })
    },
    async draftReport() {
      await this.getValuesFromReportPage()
      await this.$store.dispatch('DRAFT_REPORT', {
        id: this.id,
        statReportId: this.statReportId,
        report: this.report,
        ...this.params
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  background-color: #efeff4;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportPage/index.vue